const styles = theme => ({
  // Root styles
  customDomain__root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 16,
  },

  // Typography styles
  embedInstructionText: {
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'Inter',
  },
  headTagHighlight: {
    color: '#015ffb',
  },

  // Button styles
  customDomain__addDomainButton: {
    backgroundColor: '#015FFB',
    color: '#fff',
    borderRadius: '12px',
    width: '100%',
    border: 'none',
    boxShadow: 'none',
    height: '40px',
    '&:hover': {
      backgroundColor: '#3a92e9',
    },
  },

  // WordPress plugin container
  wordpressPluginContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: '8px 12px',
    backgroundColor: '#F4F6F8',
    borderRadius: '8px',
    width: '100%',
    alignItems: 'center',
    gap: 8,
  },

  // WordPress plugin text
  wordpressPluginText: {
    width: '100%',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 400,
  },
})

export default styles
